export default function EmployeeProfile() {
    const profile = {
      name: "Employee Name",
      email: "employee@example.com",
      department: "IT",
      position: "Developer",
      leaveBalance: 12,
      attendance: "95%",
    };
  
    return (
      <div className="space-y-6">
        <h1 className="text-4xl font-bold text-purple-600">My Profile</h1>
  
        <div className="bg-white rounded-xl shadow-lg p-6 space-y-4">
          {Object.entries(profile).map(([key, value]) => (
            <div key={key} className="flex justify-between border-b border-gray-200 p-2">
              <span className="font-semibold capitalize">{key.replace(/([A-Z])/g, " $1")}</span>
              <span className="text-gray-700">{value}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
  